import { sampleWages } from '@/common/queries/selections/sampleWages';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const useSampleWages = (params: {
  name?: string;
  vehicleType?: string;
}) => {
  const sampleTypeQuery = queryOptions({
    queryKey: ['sampleWages', params],
    queryFn: () => sampleWages(params),
    select: (data) => {
      return data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
  });
  const { data: sampleWagesList } = useQuery(sampleTypeQuery);
  return { sampleWagesList };
};
